import { useState } from "react";

import { WidgetModelAdapterService } from "app/components/widget/WidgetModelAdapterService";
import { allTrackers } from "app/services/track/track";

import type { IFoldersFilters } from "../../../types";

interface IDomain {
    name: string;
    displayName: string;
    icon: string;
}

interface IRadioFilters {
    filters: IFoldersFilters;
}

interface IUseDashboardModalProps {
    radioFilters: IRadioFilters;
    domainObj?: IDomain;
}

export const useDashboardModal = ({ radioFilters, domainObj }: IUseDashboardModalProps) => {
    const [isOpen, setIsOpen] = useState(false);
    const [customModel, setCustomModel] = useState(null);

    const getCustomModel = async () => {
        try {
            const model = WidgetModelAdapterService.getInstance().fromWebsite(
                "LeadingFolders",
                "Table",
                "Total",
                false,
                radioFilters.filters,
                undefined,
            );

            return domainObj
                ? {
                      ...model,
                      key: [{ image: domainObj.icon, name: domainObj.name }],
                  }
                : model;
        } catch (error) {
            console.error("Failed to create custom model:", error);
            return null;
        }
    };

    const handleClose = () => {
        setIsOpen(false);
        setCustomModel(null);
    };

    const handleOpenDashboard = async () => {
        allTrackers.trackEvent("Pop up", "open", "Add to my Dashboard/Folders Table");

        const model = await getCustomModel();
        if (model) {
            setCustomModel(model);
            setIsOpen(true);
        }
    };

    return {
        isOpen,
        customModel,
        handleClose,
        handleOpenDashboard,
    };
};
